import { Account, Email } from '../types/email'

export const mockAccounts: Account[] = [
  {
    id: 'acc-1',
    email: 'brett@gmail.com',
    name: 'Brett Haralson',
    provider: 'gmail',
    color: '#EA4335'
  },
  {
    id: 'acc-2',
    email: 'brett@company.com',
    name: 'Brett Haralson',
    provider: 'outlook',
    color: '#0078D4'
  }
]

export const mockEmails: Email[] = [
  {
    id: 'email-1',
    accountId: 'acc-1',
    from: { name: 'Sarah Chen', email: 'sarah.chen@techcorp.com' },
    to: [{ name: 'Brett Haralson', email: 'brett@gmail.com' }],
    subject: 'Q4 Planning Meeting - Action Items',
    body: `Hi Brett,

Great meeting today! Here are the action items we discussed:

1. Finalize the budget proposal by Friday
2. Schedule follow-up meetings with the design team
3. Review the new product roadmap

Let me know if you have any questions.

Best,
Sarah`,
    preview: 'Great meeting today! Here are the action items we discussed...',
    date: new Date(Date.now() - 1000 * 60 * 30), // 30 mins ago
    isRead: false,
    isStarred: true,
    folder: 'inbox'
  },
  {
    id: 'email-2',
    accountId: 'acc-2',
    from: { name: 'Mike Johnson', email: 'mike.j@startup.io' },
    to: [{ name: 'Brett Haralson', email: 'brett@company.com' }],
    subject: 'Partnership Opportunity',
    body: `Hello Brett,

I hope this email finds you well. I wanted to reach out regarding a potential partnership between our companies.

We've been following your work and believe there could be significant synergies between our platforms.

Would you be available for a call next week to discuss further?

Best regards,
Mike Johnson
CEO, Startup.io`,
    preview: 'I wanted to reach out regarding a potential partnership...',
    date: new Date(Date.now() - 1000 * 60 * 60 * 2), // 2 hours ago
    isRead: false,
    isStarred: false,
    folder: 'inbox'
  },
  {
    id: 'email-3',
    accountId: 'acc-1',
    from: { name: 'GitHub', email: 'noreply@github.com' },
    to: [{ name: 'Brett Haralson', email: 'brett@gmail.com' }],
    subject: '[InboxOne] Pull request merged',
    body: `Your pull request #42 has been successfully merged into main.

View the commit: https://github.com/user/inboxone/commit/abc123

Thanks for your contribution!`,
    preview: 'Your pull request #42 has been successfully merged into main.',
    date: new Date(Date.now() - 1000 * 60 * 60 * 5), // 5 hours ago
    isRead: true,
    isStarred: false,
    folder: 'inbox'
  },
  {
    id: 'email-4',
    accountId: 'acc-2',
    from: { name: 'HR Team', email: 'hr@company.com' },
    to: [{ name: 'Brett Haralson', email: 'brett@company.com' }],
    subject: 'Updated PTO Policy - Please Review',
    body: `Dear Team,

We've updated our PTO policy for the new year. Key changes include:

- Increased annual leave from 15 to 20 days
- New mental health day allowance (3 days)
- Simplified request process

Please review the attached document and acknowledge by Friday.

HR Team`,
    preview: "We've updated our PTO policy for the new year...",
    date: new Date(Date.now() - 1000 * 60 * 60 * 24), // 1 day ago
    isRead: true,
    isStarred: true,
    folder: 'inbox'
  },
  {
    id: 'email-5',
    accountId: 'acc-1',
    from: { name: 'Netflix', email: 'info@netflix.com' },
    to: [{ name: 'Brett Haralson', email: 'brett@gmail.com' }],
    subject: 'New releases this week',
    body: `Check out what's new on Netflix this week!

- The Crown: Season 6
- New documentary series
- Action thriller premiere

Watch now at netflix.com`,
    preview: "Check out what's new on Netflix this week!",
    date: new Date(Date.now() - 1000 * 60 * 60 * 48), // 2 days ago
    isRead: true,
    isStarred: false,
    folder: 'inbox'
  },
  {
    id: 'email-6',
    accountId: 'acc-1',
    from: { name: 'Brett Haralson', email: 'brett@gmail.com' },
    to: [{ name: 'Sarah Chen', email: 'sarah.chen@techcorp.com' }],
    subject: 'Re: Q4 Planning Meeting - Action Items',
    body: `Hi Sarah,

Thanks for the summary! I'll have the budget proposal ready by Thursday.

Quick question - should we include the contingency fund in this quarter's budget?

Best,
Brett`,
    preview: "Thanks for the summary! I'll have the budget proposal ready...",
    date: new Date(Date.now() - 1000 * 60 * 15), // 15 mins ago
    isRead: true,
    isStarred: false,
    folder: 'sent'
  },
  {
    id: 'email-7',
    accountId: 'acc-2',
    from: { name: 'Brett Haralson', email: 'brett@company.com' },
    to: [{ name: 'Team', email: 'team@company.com' }],
    subject: 'Weekly Status Update',
    body: `Hi Team,

Here's the weekly status update:

Completed:
- Feature A implementation
- Bug fixes for release 2.1

In Progress:
- Integration testing
- Documentation updates

Blockers:
- None

Let me know if you have any questions!

Brett`,
    preview: "Here's the weekly status update...",
    date: new Date(Date.now() - 1000 * 60 * 60 * 3), // 3 hours ago
    isRead: true,
    isStarred: false,
    folder: 'sent'
  },
  {
    id: 'email-8',
    accountId: 'acc-1',
    from: { name: 'Brett Haralson', email: 'brett@gmail.com' },
    to: [{ name: 'Mom', email: 'mom@email.com' }],
    subject: 'Dinner plans for Sunday',
    body: `Hey Mom,

Looking forward to dinner on Sunday! Should I bring anything?

Love,
Brett`,
    preview: 'Looking forward to dinner on Sunday!',
    date: new Date(Date.now() - 1000 * 60 * 60 * 26), // yesterday
    isRead: true,
    isStarred: true,
    folder: 'sent'
  }
]

export const getInboxEmails = () => mockEmails.filter(e => e.folder === 'inbox')
export const getSentEmails = () => mockEmails.filter(e => e.folder === 'sent')
export const getAccountById = (id: string) => mockAccounts.find(a => a.id === id)
